import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";

import { useTheme } from "@mui/material/styles";
import { FC, useState } from "react";
import { InfoBox } from "../designUi";
import SupportTable from "./supportTable";

import { SupportIconLarge } from "../UIElements/svg-icons";
import { SupportDetailsModal } from "./support-modal";
import { PaginationDetails } from "../../interface/api_request";
import { Pagination } from "../Pagination";

const SupportContent: FC<{
  supportList: any[];
  stats: any;
  paginationState: PaginationDetails;
  setPaginationState: React.Dispatch<React.SetStateAction<PaginationDetails>>;

  handleRefresh: () => void;
  loading: boolean;
}> = ({
  supportList,
  stats,
  paginationState,
  setPaginationState,
  loading,
  handleRefresh,
}) => {
  const theme = useTheme();

  const [modalState, setModalState] = useState({
    sopportDetails: {},
    modal: false,
  });
  const isMedium = useResponsive("down", "md", "xs");
  const isSmall = useResponsive("down", "sm", "xl");

  const handleModal = (data: any) =>
    setModalState((prev) => ({ sopportDetails: data, modal: !prev.modal }));

  const handleClose = () =>
    setModalState((prev) => ({ ...prev, modal: !prev.modal }));

  return (
    <>
      <SupportDetailsModal
        open={modalState?.modal}
        modalHandler={handleClose}
        handleRefresh={handleRefresh}
        supportData={modalState?.sopportDetails}
      />
      <Stack sx={{ padding: 2, marginTop: 70 }}>
        <Grid container>
          <Grid
            item
            xs={isSmall ? 12 : isMedium ? 6 : 4}
            sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
          >
            <InfoBox
              title={"Total Tickets"}
              value={stats?.totalIssues ?? 0}
              icon={<SupportIconLarge />}
            />
          </Grid>
          <Grid
            item
            xs={isSmall ? 12 : isMedium ? 6 : 4}
            sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
          >
            <InfoBox
              title={"Resolved Tickets"}
              value={stats?.resolvedIssues ?? 0}
              icon={<SupportIconLarge />}
            />
          </Grid>{" "}
          <Grid
            item
            xs={isSmall ? 12 : isMedium ? 6 : 4}
            sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
          >
            <InfoBox
              title={"Pending Tickets"}
              value={stats?.pendingIssues ?? 0}
              icon={<SupportIconLarge />}
            />
          </Grid>{" "}
        </Grid>
        <Box
          sx={{
            width: "100%",
            marginY: 4,
            marginX: 2,
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: "#000E2C",
              fontFamily: "Inter",
            }}
          >
            Support
          </Typography>
          <Stack sx={{ my: 2, width: "98%" }}>
            <SupportTable
              data={supportList}
              loading={loading}
              handleModal={handleModal}
              modalState={modalState}
            />
          </Stack>
          <Pagination paginationState={paginationState} setPaginationState={setPaginationState} />
        </Box>
      </Stack>
    </>
  );
};

export default SupportContent;
